import React from 'react';
import styled from 'styled-components';
import { Nav } from '@catalogo/core-nav';

const Text = styled.span`
  color: ${({ theme }) => theme.primaryColor};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: bold;
`;

const View = styled.div`
  text-align: right;
  margin: 12px 15px 24px 0;
`;

const ReportLink = ({ id }) => (
  <View>
    <Nav to={`/denuncie/${id}`}>
      <Text>denunciar anúncio</Text>
    </Nav>
  </View>
);

export default ReportLink;
